import _ from "lodash";
import BaseSecondaryStickyView from "scripts/views/baseSecondaryStickyNavView";
import templateCollectionPageNav from "templates/collectionPageNav.hbs";
import mediaPageNavTranslations from "i18n/mediaPageNavTranslations";

class CollectionPageNavView extends BaseSecondaryStickyView {
  get template() {
    return templateCollectionPageNav;
  }

  constructor(options) {
    super(options);

    this.collectionModel = options.collectionModel;

    this.mediaPageNavTranslations = new mediaPageNavTranslations();
  }

  render() {
    this.$el.html(
      this.template(
        _.merge(
          {
            i18n: this.mediaPageNavTranslations.getTranslations(),
          },
          this.model.toJSON(),
          this.collectionModel.toJSON(),
        ),
      ),
    );

    this.updateLinkState();
    this.updatePosition();

    return this;
  }
}

export default CollectionPageNavView;
